import { setModalStatus } from 'redux/slices/modal.slice';
import { setConektaPaymentAction } from 'features/payments/state/payments.slice';
import { savePendingConektaOrderId } from 'features/payments/utils/conekta-pending-order.util';
import { MODAL_NAMES } from 'utils/constants';

// ---- GUARDA LA ACCIÓN DE PAGO DE CONEKTA Y ABRE EL MODAL DE VERIFICACIÓN 3DS ----
export const handleConektaPaymentAction = paymentAction => dispatch => {
  // Fuera de Redux también, porque el componente de Conekta puede navegar la ventana
  // completa a la `return_url` y llevarse el estado. Ver conekta-pending-order.util.
  savePendingConektaOrderId(paymentAction.orderId);

  dispatch(setConektaPaymentAction(paymentAction));
  dispatch(
    setModalStatus({
      name: MODAL_NAMES.CONEKTA_3DS,
      isActive: true,
    }),
  );
};
